/**
 * This extension prints number of files inserted into <input type="file" multiple />
 */
export function registerFileUploadCountListeners(snippet: HTMLElement): void {
    snippet.querySelectorAll('form .drag-drop-file-upload').forEach(element => {
        element.addEventListener('change', (e) => {
            const parent = element.parentElement;

            if (parent === null) {
                return;
            }

            const input = e.target as HTMLInputElement;
            const paragraph = parent.querySelector('p');

            if (paragraph === null || input.files === null) {
                return;
            }

            paragraph.textContent = 'Počet souborů: ' + input.files.length;
        });
    });
}
